export const NEW_CUSTOMER_TITLE = 'New visitor';
export const RETURNING_CUSTOMER_TITLE = 'Returning visitor';
